import React from 'react';
import { Snackbar, IconButton } from "@material-ui/core";
import { Close as CloseIcon, Info as InfoIcon } from "@material-ui/icons";

import { clearStorage } from '../../../utils/helper';
import { TIMEOUT_ID } from '../../../constants.js';


export default class Timeout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            timeLeft: 10,
            timeoutWarning: false,
        }
        this.handleDismiss = this.handleDismiss.bind(this);
    }

    componentDidMount() {
        window.sessionStorage.removeItem(TIMEOUT_ID);
    }

    componentDidUpdate(prevProps) {
        const { idle } = this.props;

        if (idle !== prevProps.idle) {
            if (idle === true) {
                this.setState({ timeoutWarning: true }, this.countdownTimer);
            }

            if (idle === false) {
                this.setState({ timeoutWarning: false }, this.resetTimer);
            }
        }
    }

    countdownTimer() {
        this.timer = setInterval(() => {
            this.setState(state => {
                if (state.timeLeft === 1) {
                    this.handleLogout();
                    return null;
                }
                return { timeLeft: state.timeLeft - 1};
            });
        }, 1000)
    }

    resetTimer() {
        this.setState({ timeLeft: 10 });
        clearInterval(this.timer);
    }

    handleDismiss() {
        this.setState({ timeoutWarning: false });
        window.sessionStorage.removeItem(TIMEOUT_ID);
    }

    handleLogout() {
        clearStorage();
        window.sessionStorage.setItem(TIMEOUT_ID, 1);
        window.location.href = window.location.origin + '/login';
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const { timeoutWarning, timeLeft } = this.state;
        const appTimedOut = window.sessionStorage.getItem(TIMEOUT_ID);

        return (
            <React.Fragment>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={timeoutWarning || Boolean(appTimedOut)}
                    onClose={this.handleDismiss}
                    ContentProps={{
                        'aria-describedby': 'timeout-notify'
                    }}
                    message={
                        (
                            <span id="timeout-notify" className="timeout-notify">
                                <InfoIcon />
                                {
                                    timeoutWarning &&
                                    `The appplication will time out in ${timeLeft} seconds.`
                                }
                                {
                                    appTimedOut &&
                                    `The application timed out due to inactivity. Please log in again.`
                                }
                            </span>
                        )
                    }
                    action={[
                        <IconButton
                            key='close'
                            color='inherit'
                            aria-label='Close'
                            onClick={this.handleDismiss}
                        >
                            <CloseIcon />
                        </IconButton>
                    ]}
                />
            </React.Fragment>
        )
    }
}
